/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Workout_ThresholdInputs */

const en_coach_workout_threshold = /** @type {(inputs: Coach_Workout_ThresholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5x5min Threshold`)
};

const de_coach_workout_threshold = /** @type {(inputs: Coach_Workout_ThresholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5x5min Schwelle`)
};

/**
* | output |
* | --- |
* | "5x5min Threshold" |
*
* @param {Coach_Workout_ThresholdInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_workout_threshold = /** @type {((inputs?: Coach_Workout_ThresholdInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Workout_ThresholdInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_workout_threshold(inputs)
	return de_coach_workout_threshold(inputs)
});